import { ErrorPage } from './errorPage'

export * from './errorPage'

export default ErrorPage